function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBreakNomeal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "126px",
    height: "75px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "none"
    },
    d: "M0 0L0 75L76 75L76 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "none"
    },
    d: "M31 5L31 21L33 21L33 5L31 5M39 9L39 21L41 21L41 9L39 9M23 13L23 21L25 21L25 13L23 13M47 13L47 21L49 21L49 13L47 13M14 23L14 55C14.0003 59.355 13.2676 64.962 16.6528 68.3472C20.4104 72.1049 27.1862 71 32 71C44.059 71 57.8579 73.898 58 58C73.367 56.2884 73.367 33.7116 58 32L58 23L14 23z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f37161",
      stroke: "none"
    },
    d: "M18.6034 27.0278C15.1709 29.7464 17 40.0625 17 44C17 49.6758 15.0609 59.8411 18.0278 64.8519C21.1774 70.1713 48.1267 70.2347 52.6821 66.3966C56.761 62.96 55 53.7531 55 49C55 43.9124 57.2369 31.7254 53.9722 27.6034C52.2552 25.4355 48.4197 26.005 46 26C39.7886 25.9872 23.5607 23.1016 18.6034 27.0278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#757575",
      stroke: "none"
    },
    d: "M58.6667 31.3333L59.3333 31.6667L58.6667 31.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f37161",
      stroke: "none"
    },
    d: "M58 34L58 56C69.5544 52.0607 69.5544 37.9393 58 34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fffefe",
      stroke: "none"
    },
    d: "M23 36L23 40L25 40L25 36L23 36z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#818181",
      stroke: "none"
    },
    d: "M69 41L70 42L69 41z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ffffff",
      stroke: "none"
    },
    d: "M23 42L23 63L25 63L25 42L23 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#818181",
      stroke: "none"
    },
    d: "M69 48L70 49L69 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#757575",
      stroke: "none"
    },
    d: "M58.6667 58.3333L59.3333 58.6667L58.6667 58.3333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#939393",
      stroke: "none"
    },
    d: "M14 65L15 66L14 65M57 65L58 66L57 65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#a8a8a8",
      stroke: "none"
    },
    d: "M15 67L16 68L15 67M56 67L57 68L56 67M17 69L18 70L17 69M54 69L55 70L54 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#939393",
      stroke: "none"
    },
    d: "M19 70L20 71L19 70M52 70L53 71L52 70z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreakNomeal);
export default __webpack_public_path__ + "static/media/break_nomeal.23f028e6cf3f108ac09cc2f8cb849ce3.svg";
export { ForwardRef as ReactComponent };